import { useContext, useEffect, useLayoutEffect } from "react"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import {
  populateRefiners,
  reviewSelection,
} from "components/Stacker/actions/StackerActions"
import App from "components/Stacker/components/App/App"
import BraceletsProductFilter from "components/Stacker/components/Bracelets/BraceletProductList/BraceletFilter"
import BraceletsProductList from "components/Stacker/components/Bracelets/BraceletProductList/BraceletProductList"
import BraceletStacker from "components/Stacker/components/Bracelets/BraceletStacker/BraceletStacker"
import IntroCarousel from "components/Stacker/components/Bracelets/IntroCarousel/IntroCarousel"
import AmountModal from "components/Stacker/components/Common/Modals/AmountModal"
import HelpModal from "components/Stacker/components/Common/Modals/HelpModal"
import ShareModal from "components/Stacker/components/Common/Modals/ShareModal"
import ProductList from "components/Stacker/components/ProductList/ProductList"
import ModalConfig from "components/Stacker/config/ModalConfig"
import SC from "components/Stacker/constants/StackerConstants"
import isMobile from "components/Stacker/utils/device-check"
import {
  createCookie,
  getCookieValue,
} from "components/Stacker/lib/get-domain-cookie"
import queryString from "query-string"
import { ensureStackerStyles } from "components/Stacker/components/Common/helpers"
import "./BraceletStackerPage.scss"
import { getDY_SR, setDY } from "stackerConfig"
import { shallowEqual, useDispatch } from "react-redux"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useState } from "react"
import { useCallback } from "react"
import { useI18nContext } from "i18n/i18n-react"
import { shadowDOM } from "components/Stacker/utils/shadowDOM"

function BraceletStackerPage() {
  const dispatch = useDispatch()
  const location = useLocation()
  //const navigate = useNavigate()
  const { LL } = useI18nContext()
  const stackerContext = useContext(StackerContext)
  const isAppLoaded = useSelector((state) => state.stacker.isAppLoaded)
  const selectedAmount = useSelector((state) =>
    state.stacker.addedStack ? state.stacker.addedStack.length : 0
  )
  const searchBracelets = useSelector(
    (state) => state.braceletStacker.search,
    shallowEqual
  )
  const added = useSelector((state) => state.stacker.addedStack, shallowEqual)

  const addedRetailerProducts = useSelector((state) => {
    return state.retailer.retailerProducts.filter((_) =>
      added.some((a) => a.indexOf(_.baseProduct) != -1)
    )
  })

  const queryObj = queryString.parse(location.search, { decode: true })
  const [searchParams, setSearchParams] = useState({
    ...searchBracelets,
    q: getDY_SR().config.braceletStacker.braceletCategory,
    fq: queryObj.fq,
    sort: queryObj.sort,
  })

  // const selectedProduct = useSelector(
  //   (state) => state.braceletStacker.productInfo
  // )
  // const isRearrange = useSelector((state) => state.stacker.isRearrange)
  // const isReviewing = useSelector((state) => state.stacker.isReviewing)
  // const pdp = useSelector((state) => state.pdp)
  // const selected = useSelector((state) => state.stacker.addedStack)

  setDY("bracelets")

  const main = shadowDOM.getElementById("stacker-root")
  main.classList.add("stacker-bracelets-root")

  useLayoutEffect(() => {
    const queryObj = queryString.parse(location.search, { decode: true })

    setSearchParams({
      ...searchBracelets,
      q: getDY_SR().config.braceletStacker.braceletCategory,
      fq: queryObj.fq,
      sort: queryObj.sort,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBracelets, location.search])

  useEffect(() => {
    ensureStackerStyles()
  }, [])

  // TODO: confirm it's not needed
  // useEffect(() => {
  //   const products = wrapQueryArray(queryString.parse(location.search).products)
  //   if (products.length > 0) {
  //     dispatch(previewSelection(true))
  //   }
  // }, [location, dispatch])

  const onPreviewClick = useCallback((e) => {
    e.preventDefault()
    //dispatch(previewSelection(true))
  }, [])

  const onShareClick = useCallback(
    (e) => {
      e.preventDefault()
      dispatch(toggleModal(ModalConfig.MODAL_STACKER_SHARE, true))
    },
    [dispatch]
  )

  const onHelpClick = useCallback(
    (e) => {
      if (e) {
        e.preventDefault()
      }
      dispatch(toggleModal(ModalConfig.MODAL_STACKER_HELP, true))
    },
    [dispatch]
  )

  useEffect(() => {
    if (isAppLoaded) {
      const tutorialViewCookieValue = getCookieValue(
        SC.BRACELET_TUTORIAL_COOKIE
      )
      const tutorialViewedCookie = {
        cookieName: SC.BRACELET_TUTORIAL_COOKIE,
        cookieValue: true,
        cookiePath: true,
      }
      if (!tutorialViewCookieValue) {
        createCookie(tutorialViewedCookie)
        setTimeout(() => onHelpClick(null), 500)
      }
    }
  }, [isAppLoaded, onHelpClick])

  const onReviewClick = useCallback(
    (e) => {
      stackerContext.getInstance().onSelectionReviewed()
      e.preventDefault()
      const refinerData = {
        addedStack: added,
        addedRetailerProducts: addedRetailerProducts,
      }
      dispatch(
        populateRefiners({
          data: refinerData,
        })
      )
      dispatch(reviewSelection(true))
    },
    [dispatch, stackerContext, added, addedRetailerProducts]
  )

  const stackerStyle = "col-md-7"
  const productListStyle = "col-md-5"

  return (
    <App appType="bracelets" searchParams={searchParams}>
      <App.Stacker styles={stackerStyle}>
        {isAppLoaded && (
          <>
            <BraceletStacker
              onHelpClick={onHelpClick}
              onShareClick={onShareClick}
            />
            <HelpModal modalName={ModalConfig.MODAL_STACKER_HELP}>
              <IntroCarousel />
            </HelpModal>
            <ShareModal />
            <AmountModal />
          </>
        )}
      </App.Stacker>
      <App.ProductList styles={productListStyle}>
        <ProductList
          columns={2}
          pageSize={searchBracelets.pageSize}
          productType="bracelet"
        >
          <ProductList.Header>
            <BraceletsProductFilter
              searchParams={searchParams}
              onHelpClick={onHelpClick}
            />
          </ProductList.Header>
          <ProductList.Body>
            <BraceletsProductList />
          </ProductList.Body>
          <ProductList.Footer>
            <button
              className="btn btn-blackrect d-block mx-auto w-100"
              disabled={selectedAmount === 0}
              onClick={onReviewClick}
            >
              {LL.bracelets.reviewStack()}
            </button>
          </ProductList.Footer>
        </ProductList>
      </App.ProductList>
    </App>
  )
}

export default BraceletStackerPage
